import React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import "./index.css";

type PropsType = {
    children: React.ReactNode;
    setIsConfigurationModalOpened: React.Dispatch<
        React.SetStateAction<boolean>
    >;
    isConfigurationModalOpened: boolean;
    shopName?: string;
    onSave?: () => void;
    isLoading?: boolean;
};

export function ServioModalWrapper({
    children,
    setIsConfigurationModalOpened,
    isConfigurationModalOpened,
    shopName,
    onSave,
    isLoading = false,
}: PropsType): JSX.Element {
    const { t } = useTranslation();

    const handleClose = () => {
        setIsConfigurationModalOpened(false);
    };

    const handleSave = () => {
        if (onSave) {
            onSave();
        } else {
            handleClose();
        }
    };

    return (
        <React.Fragment>
            <Modal
                data-testid="servio-modal-wrapper"
                centered
                backdrop="static"
                fade={false}
                scrollable
                isOpen={isConfigurationModalOpened}
                className="servio-modal-wrapper__clz"
            >
                <ModalHeader
                    data-testid="servio-modal-wrapper-header"
                    toggle={handleClose}
                    className="text-uppercase"
                >
                    {t("Servio Configuration")}
                    {shopName ? ` - ${shopName}` : ""}
                </ModalHeader>
                <ModalBody
                    className="p-0"
                    data-testid="servio-modal-wrapper-body"
                >
                    {children}
                </ModalBody>
                <ModalFooter data-testid="servio-modal-wrapper-footer">
                    <CustomMainColorButton
                        data-testid="servio-modal-wrapper-save-btn"
                        className="w-20 servio_btn_save"
                        rounded
                        variant="primary"
                        onClick={handleSave}
                        disabled={isLoading}
                    >
                        {t("Save")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
